<app-landingpage-header-child></app-landingpage-header-child>
<div  style="overflow: hidden" id="view-document-anonymous">
  <div class="row">
    <div class="col-12 mobile">
      <h5 class="px-1 pt-1">{{"breadcrumbs.document_view" | translate}} {{ document.name }}</h5>
    </div>
    <div [ngClass]="{ 'col-lg-5 ': !isFullviewPdf }" [hidden]="isFullviewPdf" class="col-md-12 col-sm-12 pr-0">
      <div #focus tabindex="-1" class="card" style="
          height: calc(100vh - 140px);
          overflow-y: scroll;
          border-radius: unset !important;
          padding-bottom: 50px;
        ">
        <app-anonymous-detail-panel #is *ngIf="document" (isSignNowParent)="onAttachmentChange($event)"  (isSetUpSignFlowParent)="onAttachmentApproverChange($event)"></app-anonymous-detail-panel>
        <div *ngIf="listApproverSign.length > 0">
          <mat-expansion-panel  [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title class panel-title">
                {{ "approved.info_approved" | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <mat-label>{{ "file_sign" | translate }}
              </mat-label>
              <mat-form-field class="w-100">


                <mat-select (selectionChange)="changeFileAddSign($event,'selectFileSign')"
                            [(ngModel)]="selectedFileSign">
                  <mat-option *ngFor="let file of fileUploads;let i = index" [value]="i">
                    {{ file.fileName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <nz-table #expandTable nzTableLayout="fixed" [nzFrontPagination]="false" [nzShowPagination]="false" class="ant-table-no-placeholder-border-bottom table-user-sign" nzBordered >
              <thead>
              <tr>
                <th class="text-center" nzWidth="10%">
                  {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}
                </th>
                <th class="text-center" nzWidth="40%">
                  {{ "enterprise_contract.panel_document.table_users.header.name" | translate }}
                </th>
<!--                <th class="text-center" nzWidth="25%">-->
<!--                  {{ "enterprise_contract.panel_document.table_users.header.role" | translate }}-->
<!--                </th>-->
                <th class="text-center" nzWidth="10%" *ngIf="checkCTSShowImage.length > 0 && checkShowImage ">
                  {{ "enterprise_contract.panel_document.table_users.header.page" | translate }}
                </th>
                <th class="text-center" nzWidth="15%" *ngIf="checkCTSShowImage.length > 0 && checkShowImage ">
                  {{ "enterprise_contract.panel_document.table_users.header.action" | translate }}
                </th>
              </tr>
              </thead>
              <tbody>
              <!-- nguoi dung phe duyet ben lap -->
              <ng-container *ngFor="let data of listApproverSign; let i = index">
                <tr>
                  <td class="text-center">1</td>
                  <td>
                    {{ data.fullName }}
                  </td>
<!--                  <td class="text-center">-->
<!--                    {{'search_form.approve_doc' | translate}}-->
<!--                  </td>-->
                  <td *ngIf="checkCTSShowImage.length > 0 && checkShowImage "></td>
                  <td class="text-center" *ngIf="data.CTS && data.showImage">
                    <button (click)="addSign(data)" color="primary" mat-icon-button
                            type="button">
                      <mat-icon class="mr-0" matTooltip="{{
                          'enterprise_contract.tooltips.add_sign' | translate
                        }}">add_circle
                      </mat-icon>
                    </button>
                  </td>
                  <td *ngIf="(!data.CTS || !data.showImage) && checkCTSShowImage.length > 0 && checkShowImage"></td>
                </tr>
                <ng-container *ngFor="let sign of listSignNew; let id = index">
                  <tr *ngIf="sign.userId == data.userId && checkHaveSign(data, sign)">
                    <td></td>
                    <td > {{ "signature_number" | translate }} {{sign.row_number}}</td>
                    <td class="text-center">{{sign.pageIndex}}</td>
                    <td class="text-center">
                      <button (click)="goToPage(data.enterpriseId, data.userId, sign)"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                        </mat-icon>
                      </button>
                      <!-- <button (click)="deleteSign(data.enterpriseId, data.userId, sign.idNumber)" *ngIf="checkHaveSign(data, sign.idNumber)" -->
                      <button (click)="deleteSign(data.enterpriseId, data.userId, (sign.contractSignId || sign.idNumber))"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                        </mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </nz-table>
          </mat-expansion-panel>

        </div>
        <!--        <app-panel-setup-sign-flow-receive [documentInfo]="document" *ngIf="isSetupSignFlow" ></app-panel-setup-sign-flow-receive>-->
      </div>
    </div>
    <div [ngClass]="{ 'col-lg-7 ': !isFullviewPdf, 'col-lg-12': isFullviewPdf }" class="col-md-12 col-sm-12"
      [class.pl-0]="!isFullviewPdf" style="padding-right: 0.75rem" [class.mobile-hidden]="!isFullviewPdf">
      <div class="mat-elevation-z0 border-bottom" #headerControll [ngStyle]="{
          background:
            document.typeId === 1 &&
            document.mainContractAttachments &&
            document.mainContractAttachments.length
              ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
              : '#fff'
        }">
        <div class="d-flex justify-content-between">
          <div class="py-2 px-3 bg-white d-flex desktop" [ngStyle]="{
              'border-bottom-right-radius':
                document.typeId === 1 && activeFile === 0 ? '5px' : '0'
            }" id="box-left" style="max-width: 25vw">
            <div *ngIf="isShowChangeViewBtn">
              <button class="mr-2 ml-2" color="primary" mat-icon-button (click)="tongleFullviewPdf()">
                <mat-icon [hidden]="isFullviewPdf" class="fullview-icon" matTooltip="{{
                    'enterprise_contract.tooltips.btn_expand_more' | translate
                  }}">
                  arrow_back_ios
                </mat-icon>
                <mat-icon [hidden]="!isFullviewPdf" class="fullview-icon" matTooltip="{{
                    'enterprise_contract.tooltips.btn_expand_less' | translate
                  }}">
                  arrow_forward_ios
                </mat-icon>
              </button>
            </div>
            <span style="max-width: calc(100% - 40px)" [matTooltip]="
                documentParentName
                  ? document.name + ' - ' + documentParentName
                  : document.name
              " class="name-contract">
              <strong> {{ document.name }} </strong>
              <strong *ngIf="document.parentId">
                - {{ documentParentName }}
              </strong>
            </span>
          </div>
          <div class="d-flex" id="box-center" style="width: 100%" *ngIf="document.typeId === 1 || document.typeId === 0">
            <div style="width: 100%; position: relative; height: 52px">
              <div class="d-flex box-tab" style="
                  position: absolute;
                  width: 100%;
                  top: 0.5rem;
                  left: 0;
                  height: calc(52px - 0.5rem);
                ">
                <div class="pl-1 py-2 tab" *ngFor="
                    let file of document.mainContractAttachments;
                    let i = index
                  " [class.active]="i === activeFile" [class.left]="i === activeFile - 1"
                  [class.right]="i === activeFile + 1" (click)="changeFile(file.path, i)"
                  [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1"
                  [matTooltip]="file.fileName">
                  <div class="name">
                    <i nz-icon [nzType]="'loading'" *ngIf="file.loading"></i>
                    {{ file.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-3 py-2 bg-white" style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            " [ngStyle]="{
              'border-bottom-left-radius':
                document.typeId === 1 &&
                activeFile === document.mainContractAttachments.length - 1
                  ? '5px'
                  : '0'
            }" id="box-right">
            <button (click)="doPrint()" mat-stroked-button class="mr-2" color="primary" style="min-width: 70px !important;">
              <mat-icon class="mr-0">print</mat-icon>
              {{ "enterprise_contract.buttons.print" | translate }}
            </button>
            <button mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary"
              (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{ "enterprise_contract.buttons.download" | translate }}
            </button>
            <button mat-icon-button class="btn-download-file-sm mobile" color="primary"
              (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
            </button>
          </div>

          <!-- <div class="col-12 col-sm-3 pr-075"
            [matTooltip]="documentParentName ? document.name + ' - ' + documentParentName : document.name">
            <strong> {{document.name}} </strong>
            <strong *ngIf="document.parentId"> - {{documentParentName}} </strong>
          </div>
          <div class="col-12 col-sm-9 text-right pr-075">
            <button mat-stroked-button color="primary" (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'enterprise_contract.buttons.download' | translate}}
            </button>
            <button class="ml-3" mat-stroked-button color="primary"
              *ngIf="document.typeId == documentForm && takeInfo == null && !document.isDifferentEnterprise && !warningContractQuantity && !deviceService.isMobile()"
              (click)="copyDocument(document.id)">
              <mat-icon class="mr-0">file_copy</mat-icon>
              {{'enterprise_contract.buttons.copy' | translate}}
            </button>
          </div> -->
        </div>
      </div>

      <div style="display: flex; justify-content: space-between" [class.landscape]="isViewLandscape">
        <div class="document" #focus tabindex="0" style="height: calc(100vh - 195px); width: 100%">
          <div *ngIf="
              document.typeId === documentUpload || document.negotiate === true ||
                document.status !== EnumContractStatus.DRAFT;
              else notUpload
            ">
            <ng-container *ngIf="pdfSrc != '' && checkEdit && checkTabPDF && !isShowReferencePdf && !updateInformationDialogOpen">
              <ngx-extended-pdf-viewer [src]="pdfSrc" [(page)]="pageCurrent"
                (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" useBrowserLocale="true"
                height="80vh" [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                [showPropertiesButton]="false" [showUnverifiedSignatures]="true" [theme]="'dark'" [language]="language"
                [showSecondaryToolbarButton]="false" [textLayer]="true"></ngx-extended-pdf-viewer>
            </ng-container>
            <ng-container *ngIf="pdfSrc && !checkTabPDF && document.isApproved === false && !loadSign && !isShowReferencePdf && !updateInformationDialogOpen">
              <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
                                       (textLayerRendered)="textLayerRenderedNew($event)" [(page)]="pageIndex" [enablePrint]="false"
                                       [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
                                       [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
                                       [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
                                       [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                       class="pdf-viewer" height="80vh" style="display: block" useBrowserLocale="true"
                                       >
              </ngx-extended-pdf-viewer>
            </ng-container>
            <ng-container *ngIf="pdfSrc && !checkTabPDF && document.isApproved === false && loadSign && !isShowReferencePdf && !updateInformationDialogOpen">
              <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
                                       (textLayerRendered)="textLayerRenderedNew($event)" [(page)]="pageIndex" [enablePrint]="false"
                                       [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
                                       [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
                                       [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
                                       [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                       class="pdf-viewer" height="80vh" style="display: block" useBrowserLocale="true"
              >
              </ngx-extended-pdf-viewer>
            </ng-container>
<!--            <ng-container *ngIf="pdfSrc  && !checkEdit && !checkTabPDF && !isShowReferencePdf">-->
<!--              <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"-->
<!--                                       (textLayerRendered)="textLayerRenderedNew($event)" [(page)]="pageIndex" [enablePrint]="false"-->
<!--                                       [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"-->
<!--                                       [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"-->
<!--                                       [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"-->
<!--                                       [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"-->
<!--                                       class="pdf-viewer" height="80vh" style="display: block" useBrowserLocale="true"-->
<!--              >-->
<!--              </ngx-extended-pdf-viewer>-->
<!--            </ng-container>-->
          </div>
          <ng-template #notUpload>
            <div *ngIf="pdfSrc" class="doc-wrapper view-document" [innerHTML]="pdfSrc | noSanitize"></div>
          </ng-template>
        </div>
      </div>

      <hr style="margin: 0" />
    </div>
    <div class=" bg-white text-center mat-elevation-z0 py-2 w-100 desktop" #navigation id="navigation">
      <div *ngIf="contractIdAndContractEnterpriseIdEncode && expireTime" class="expire-time font-italic p-2">
        {{ "enterprise_contract.warning_expire-time" | translate }}
        <span style="font-size:16px;font-weight: 600;">{{expireTime}}</span>
      </div>
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="canUpdateNegotiation"
        [disabled]="updateInformationDialogOpen" (click)="openDialogUpdateInformation()" type="button">
        <mat-icon class="mr-0">edit</mat-icon>
        {{ 'enterprise_contract.update_information' | translate }}
      </button>
      <ng-container *ngIf="!(document.negotiate && document.status == 1) && !permissionContractShare">
      <button mat-stroked-button color="primary" class="mr-3" *ngIf="!checkEdit" (click)="cancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="document.isApproved === false && checkEdit" type="button" (click)="onAddApproverClick()">
        <mat-icon class="mr-0">add_circle_outline</mat-icon>
        {{ "button.add_approver" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="document.isApproved === false && !checkEdit" type="button" (click)="onAddApproverClick(1)">
        <mat-icon class="mr-0">add_circle_outline</mat-icon>
        {{ "form.btn_CSTL" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="document.isApproved === false && !checkEdit" type="button" (click)="submitSign()">
        {{ "form.btn_xacnhan" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="mr-3" *ngIf="!disableSignButton && document.actionType == EnumActionType.SIGN && checkEdit && isSignNow"
        (click)="openDialogRefuseSignDocument()">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.reject" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="mr-3" *ngIf="!disableSignButton && document.actionType == EnumActionType.SIGN && checkEdit && !isSignNow"
              (click)="openLoginCaptra()">
        {{ "button.exit" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="mr-3" *ngIf="document.actionType == EnumActionType.APPROVAL  && (document.statusCu == 4 || document.statusCu == 3 || document.statusCu == 0 ||  document.status == 3) "
              (click)="openLoginCaptra()">
        {{ "button.exit" | translate }}
      </button>
      <button mat-raised-button color="primary" class="mr-3" (click)="openSignPage()" *ngIf="!disableSignButton && document.actionType == EnumActionType.SIGN && checkEdit && isSignNow "
        [disabled]="!isLoadAllPdfSrc">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="document.actionType == EnumActionType.APPROVAL  && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3" type="button" (click)="onRejectClick()">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "approved.reject_approval" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="document.actionType == EnumActionType.APPROVAL && !CheckCTS && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3" type="button" (click)="onApproverClick()" >
<!--              (click)="onApproverClick()"-->

        <mat-icon class="mr-0">check</mat-icon>
        {{ "approved.approve" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="document.actionType == EnumActionType.APPROVAL && CheckCTS  && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3" type="button" (click)="openSignPage(1)" >
        <!--              (click)="onApproverClick()"-->

        <mat-icon class="mr-0">check</mat-icon>
        {{ "approved.approve" | translate }}
      </button>
      </ng-container>
    </div>
    <!-- Button mobile -->
    <div class="scontract-btn-mobile bg-white text-center shadow-lg rounded">
      <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
        <div ngxSlickItem class="flex-fill slide" (click)="tongleFullviewPdf()" *ngIf="disableSignButton">
          <mat-icon *ngIf="!isFullviewPdf">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullviewPdf">info</mat-icon>
          <h6 class="mb-0" *ngIf="isFullviewPdf">{{ 'enterprise_contract.tooltips.info_tab' | translate }}</h6>
          <h6 class="mb-0" *ngIf="!isFullviewPdf">{{ 'enterprise_contract.tooltips.view_document' | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" *ngIf="canUpdateNegotiation" (click)="openDialogUpdateInformation()">
          <mat-icon>edit</mat-icon><h6 class="mb-0">{{ 'enterprise_contract.update_information' | translate }}</h6>
        </div>
        <ng-container *ngIf="!(document.negotiate && document.status == 1) && !permissionContractShare; else noButton">
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogRefuseSignDocument()" *ngIf="!disableSignButton && checkEdit && document.actionType == EnumActionType.SIGN && isSignNow">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">{{ "enterprise_contract.buttons.reject" | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="onRejectClick()" *ngIf="document.actionType == EnumActionType.APPROVAL && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">{{ "enterprise_contract.buttons.reject" | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="cancel()" *ngIf="!disableSignButton && !checkEdit && isSignNow">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">{{ "button.cancel" | translate }}</h6>
        </div>
        <button ngxSlickItem class="flex-fill slide" *ngIf="!disableSignButton && document.actionType == EnumActionType.SIGN && checkEdit && !isSignNow"
                (click)="openLoginCaptra()">
          {{ "button.exit" | translate }}
        </button>
        <button ngxSlickItem class="flex-fill slide" *ngIf="document.actionType == EnumActionType.APPROVAL  && (document.statusCu == 4 || document.statusCu == 3 || document.statusCu == 0 ||  document.status == 3) "
                (click)="openLoginCaptra()">
          {{ "button.exit" | translate }}
        </button>
        <div ngxSlickItem class="flex-fill slide" (click)="tongleFullviewPdf()" *ngIf="!disableSignButton">
          <mat-icon *ngIf="!isFullviewPdf">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullviewPdf">info</mat-icon>
          <h6 class="mb-0" *ngIf="isFullviewPdf">{{ 'enterprise_contract.tooltips.info_tab' | translate }}</h6>
          <h6 class="mb-0" *ngIf="!isFullviewPdf">{{ 'enterprise_contract.tooltips.view_document' | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="openSignPage()" *ngIf="!disableSignButton && checkEdit && document.actionType !== EnumActionType.APPROVAL && isSignNow ">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">{{'enterprise_contract.buttons.sign' | translate}}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="onApproverClick()" *ngIf="document.actionType == EnumActionType.APPROVAL && !CheckCTS && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">{{'approved.approve' | translate}}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="openSignPage(1)" *ngIf="document.actionType == EnumActionType.APPROVAL && CheckCTS && document.statusCu != 4 && document.statusCu != 3 && document.statusCu != 0 && document.status != 3">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">{{'approved.approve' | translate}}</h6>
        </div>
        </ng-container>
        <ng-template #noButton>
          <div ngxSlickItem class="flex-fill slide" (click)="tongleFullviewPdf()" *ngIf="!disableSignButton && permissionContractShare != 'FILE'">
            <mat-icon *ngIf="!isFullviewPdf">fullscreen</mat-icon>
            <mat-icon *ngIf="isFullviewPdf">info</mat-icon>
            <h6 class="mb-0" *ngIf="isFullviewPdf">{{ 'enterprise_contract.tooltips.info_tab' | translate }}</h6>
            <h6 class="mb-0" *ngIf="!isFullviewPdf">{{ 'enterprise_contract.tooltips.view_document' | translate }}</h6>
          </div>
        </ng-template>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
<app-landingpage-footer></app-landingpage-footer>
